import { Image } from "antd";
import { LogoStyled } from "./styles";
import { useBroker } from "../../contexts/BrokerContext";
import VeloPrimeLogo from "../../assets/veloprime/logo-veloprime-horizontal-white.png";

export const Logo: React.FC = () => {
  const { currentBroker } = useBroker();
  return (
    <LogoStyled>
      <a
        href={currentBroker?.link || "https://www.veloprime.com.br/"}
        target="_blank"
        rel="noreferrer"
      >
        <Image
          preview={false}
          alt={currentBroker?.name || "VeloPrime logo light"}
          style={{height: "32px", width: "auto"}}
          src={
            // currentBroker.iconAlternative
            //   ? currentBroker.iconAlternative
            //   : currentBroker?.icon
            //   ? currentBroker?.icon :
             VeloPrimeLogo
          }
        />
      </a>
    </LogoStyled>
  );
};
